<template>
  <v-btn
    :class="`v-btn-danger ${classP}`"
    :disabled="disabled"
    :loading="loading"
    ><slot />
  </v-btn>
</template>

<script>
export default {
  name: 'ElButtonDanger',
  props: {
    classP: String,
    disabled: Boolean,
    loading: Boolean,
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
</style>
